import ReactPDF, { View } from "@react-pdf/renderer";
import React, { Fragment } from "react";
import { Nullable } from "../../../../../types/utils";
import { OrderCategory, OrderCostingVersion, OrderStatus, TOrderCostV6, } from "../../../../api/endpoints/Order";
import { User } from "../../../../entities/User";
import { serviceChargeCost, servicePackageCost, volumeBandCost, } from "../../../../utils/Cost";
import { formatBinaryCapacityUnit, formatCurrency, } from "../../../../utils/Format";
import CostingVersion from "../OrderCostSummaryPdfV2/CostingVersion";
import LineItem from "../OrderCostSummaryPdfV2/LineItem";

interface IProps {
  user: User;
  styles: ReactPDF.Styles;
  cost: TOrderCostV6;
  currentCostingVersion?: Nullable<OrderCostingVersion>;
  orderCategory: OrderCategory;
  orderStatus: OrderStatus;
  annualTotalCostFootnoteRef?: string;
}

const OrderCostSummaryPdfV6 = (props: IProps) => {
  const { user, cost, styles, currentCostingVersion, orderCategory, annualTotalCostFootnoteRef } = props;
  const { total_cost } = cost.data;

  if (!total_cost) {
    return null;
  }

  return (
    <View>
      {
        (orderCategory === OrderCategory.REALTIME || orderCategory === OrderCategory.EU_CUTOUT) &&
        <>
          <LineItem
            styles={styles}
            label="Estimated daily volume"
            value={formatBinaryCapacityUnit(total_cost.average_daily_volume)}
          />

          <LineItem
            styles={styles}
            label="Estimated annual volume"
            value={formatBinaryCapacityUnit(total_cost.yearly_volume)}
          />

          <LineItem
            styles={styles}
            label="Volume Band cost"
            value={formatCurrency(volumeBandCost(cost))}
          />

          <LineItem
            styles={styles}
            label="Service Package cost"
            value={formatCurrency(servicePackageCost(cost))}
          />
        </>
      }

      {
        (orderCategory === OrderCategory.ARCHIVE || orderCategory === OrderCategory.WEB) &&
        <LineItem
          styles={styles}
          label="Service Charge"
          value={formatCurrency(serviceChargeCost(cost))}
        />
      }

      <LineItem
        styles={styles}
        label={`Annual total cost${annualTotalCostFootnoteRef ? ` ${annualTotalCostFootnoteRef}` : ''}`}
        value={formatCurrency(serviceChargeCost(cost))}
        highlight
      />

      <CostingVersion
        user={user}
        styles={styles}
        cost={cost as any}
        currentCostingVersion={currentCostingVersion}
        orderCategory={orderCategory}
        orderStatus={props.orderStatus}
      />
    </View>
  )
}

export default OrderCostSummaryPdfV6;
